<template>
  <description-list-item
    id="svp-expire"
    :label="label"
    :description="friendlyExpirationDate"
    :hide-label="hideLabel"
  />
</template>

<script>
import DescriptionListItem from '@/components/shared/DescriptionListItem'
export default {
  name: 'ExpireDate',
  components: {
    DescriptionListItem
  },
  props: {
    expirationDate: {
      type: [String, Date, Number],
      required: false,
      default: ''
    },
    expired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    expirationDateAsDate () {
      // return in ISO 8601 format (https://en.wikipedia.org/wiki/ISO_8601 unless someone wants to buy a copy of https://www.iso.org/standard/40874.html)
      return this.expirationDate ? new Date(this.expirationDate) : ''
    },
    friendlyExpirationDate () {
      return this.expirationDateAsDate
        ? this.expirationDateAsDate.toLocaleDateString('en-US', {
          timeZone: 'America/Los_Angeles',
          month: '2-digit',
          year: 'numeric',
          day: '2-digit'
        })
        : this.$t('expire-date.doesNotExpire')
    },
    hideLabel () {
      return !this.expirationDate && this.$vuetify.breakpoint.mobile
    },
    label () {
      return this.expired
        ? this.$t('expire-date.expired-label')
        : this.$t('expire-date.expires-label')
    }
  }
}
</script>
